import $ from 'jquery';

import { trackNewsletterSignup } from '../../scripts/tag-manager';

import './NewsletterSignupTransmitter.scss';
import template from './NewsletterSignupTransmitter.vhtml';

export default {
	name: 'NewsletterSignupTransmitter',
	template: template,
	props: {
		signupData: {
			type: Object,
			default: null,
		},
	},
	data: () => ({
		hasSubmitted: false,
		isSubmitting: false,
		submitStatus: '',
		result: {},
		honey: '',
		acceptNewsletterTerms: false,
	}),
	computed: {},
	methods: {
		submit() {
			this.hasSubmitted = true;
			this.$emit('newsletter-signup-accept', true);
			if (this.signupData !== null && this.signupData.honey === '') {
				this.isSubmitting = true;
				this.$emit('newsletter-signup-submitting', true);
				$.post('/wp-json/be/v1/newsletter-signup', JSON.stringify(this.signupData))
					.then(result => {
						if (typeof result != 'object') {
							result = JSON.parse(result)
						}
						this.isSubmitting = false;
						this.submitStatus = result.status;
						this.$emit('newsletter-signup-status', this.submitStatus);

						if (this.submitStatus === 'success') {
							trackNewsletterSignup();
						}
					})
					.catch(() => {
						this.isSubmitting = false;
						this.submitStatus = 'error';
						this.$emit('newsletter-signup-status', this.submitStatus);
					});
			}
		},
	},
};
